import { render, staticRenderFns } from "./safe-add.vue?vue&type=template&id=012edd92&scoped=true&"
import script from "./safe-add.vue?vue&type=script&lang=js&"
export * from "./safe-add.vue?vue&type=script&lang=js&"
import style0 from "./safe-add.vue?vue&type=style&index=0&id=012edd92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012edd92",
  null
  
)

export default component.exports